/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation executeScriptMutation($id: ID!, $input: JSON) {
        result: executeScript(id: $id, input: $input)
    }
`;
